// Подписи выгрузки прошлых периодов (history-export, ADR R20) — общие для
// раздела хаба и карточки выгрузки.

export const EXPORT_STATUSES = {
  draft: { label: 'Черновик', tone: 'neutral' },
  preparing: { label: 'Собираем список сделок', tone: 'info' },
  ready: { label: 'Готова к пробе', tone: 'info' },
  running: { label: 'Выполняется', tone: 'info' },
  stopping: { label: 'Прерывается', tone: 'warning' },
  stopped: { label: 'Прервана', tone: 'warning' },
  completed: { label: 'Завершена', tone: 'success' },
  completed_with_errors: { label: 'Завершена с ошибками', tone: 'warning' },
  failed: { label: 'Ошибка', tone: 'error' }
}

export function exportStatus (status) {
  return EXPORT_STATUSES[status] || { label: 'Неизвестный статус', tone: 'neutral' }
}

// 2025-01-01 → 01.01.2025
export function dayLabel (value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || ''))
  return match ? `${match[3]}.${match[2]}.${match[1]}` : null
}

export function periodLabel (from, to) {
  const start = dayLabel(from)
  const end = dayLabel(to)
  return start && end ? `${start} — ${end}` : 'Период не выбран'
}

export function dateTimeLabel (value) {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString('ru-RU')
}

// Склонение: 1 сделка, 2 сделки, 5 сделок.
export function plural (count, one, few, many) {
  const mod10 = count % 10
  const mod100 = count % 100
  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few
  return many
}

export function formatNumber (value) {
  return Number(value || 0).toLocaleString('ru-RU').replace(/[\u00a0\u202f]/g, ' ')
}

// Итог одной строкой и уточнение под ней — для списка выгрузок.
export function exportResult (item) {
  const counts = item.counts || {}
  if (['running', 'stopping'].includes(item.status)) {
    const processed = (counts.total || 0) - (counts.pending || 0)
    return { main: `отправлено ${formatNumber(processed)} из ${formatNumber(counts.total)}`, extra: null }
  }
  if (['completed', 'completed_with_errors', 'stopped'].includes(item.status)) {
    const parts = [`уже в Финтабло ${formatNumber(counts.linked)}`]
    if (counts.failed) parts.push(`с ошибкой ${formatNumber(counts.failed)}`)
    if (counts.ambiguous) parts.push(`неоднозначно ${formatNumber(counts.ambiguous)}`)
    return { main: `создано ${formatNumber(counts.created)}`, extra: parts.join(' · ') }
  }
  if (item.status === 'ready') return { main: `найдено ${formatNumber(counts.total)}`, extra: null }
  return { main: '—', extra: null }
}
